import { render, staticRenderFns } from "./myPQ.vue?vue&type=template&id=3c3e3c41&scoped=true&"
import script from "./myPQ.vue?vue&type=script&lang=js&"
export * from "./myPQ.vue?vue&type=script&lang=js&"
import style0 from "./myPQ.vue?vue&type=style&index=0&id=3c3e3c41&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3e3c41",
  null
  
)

export default component.exports